// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"eventTable__msignaturepad___2f9m1","m-signature-pad--body":"eventTable__m-signature-pad--body___N_ZSr","m-signature-pad--footer":"eventTable__m-signature-pad--footer___3tGMh","description":"eventTable__description___3S9LU","button":"eventTable__button___Qb97z","clear":"eventTable__clear___3AA86","save":"eventTable__save___3ZFpZ","m-signature-pad":"eventTable__m-signature-pad___3eEoo","github":"eventTable__github___3Aj1U","table":"eventTable__table___pROqe","header":"eventTable__header___3Lq9I","data":"eventTable__data___MO8s5"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/LineItemTable/components/eventTable.scss
// module id = fyNL
// module chunks = client